import { Component, Input } from '@angular/core';

import { MasterDataService } from '../../services/master-data.service';
import { ApiCallCachingService } from '../../services/api-call-caching.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';

import { CompanySimpleListItem } from '../../models/master-data/company-simple-list-item.model';
import { DropdownUniqueName } from '../../models/dropdown-unique-name-model';

@Component({
  selector: 'spv2-company-dropdown',
  templateUrl: './dropdown-base/dropdown-base.component.html',
  styleUrls:['./dropdown-base/dropdown-base.component.scss']
})
export class CompanyDropdownComponent extends DropdownBaseComponent<string, CompanySimpleListItem> {

  uniqueName = DropdownUniqueName.SimpleCompanyDropdown.uniqueName;

  textField = "name";
  valueField = "id";

  enableCache = true;

  dataFunction = (filter: string) => this.masterDataService.getSimpleCompanyList(filter); 

  constructor(private masterDataService: MasterDataService, cachingService: ApiCallCachingService) {
    super(cachingService);
  }

}
